<template>
  <v-container class="d-flex flex-column h-full">
    <v-card color="darknavyblue" elevation="5" class="pa-4">
      <v-card-title>Policy Export</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="exportUrl"
          label="Export URL"
          prepend-icon="mdi-export"
          hint="Paste a URL here for the policy you want to export"
          persistent-hint
        />
        <div class="ml-10">
          <v-btn
            color="primary"
            class="mt-4"
            :disabled="exportDisabled"
            :loading="exportLoading"
            @click="handleExport"
          >
            Export Policy
          </v-btn>
          <v-messages
            v-if="exportError"
            class="mt-4"
            color="error"
            v-text="exportError"
          />
        </div>
      </v-card-text>
    </v-card>

    <PolicyImportCard class="mt-8" />
  </v-container>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'

import PolicyImportCard from '@/components/PolicyImportCard.vue'
import { useApiStore } from '@/stores/api'

import { bytesToObjectURL, parseUrl } from '@/utils/api'

export default defineComponent({
  name: 'ImportExport',

  components: {
    PolicyImportCard,
  },

  setup () {
    const apiStore = useApiStore()

    // export
    const exportUrl = ref('')
    const exportLoading = ref(false)
    const exportDisabled = computed(() => {
      return !exportUrl.value || exportLoading.value
    })
    const exportError = ref<string | null>(null)
    async function handleExport (): Promise<void> {
      try {
        exportError.value = null
        exportLoading.value = true
        const url = parseUrl(exportUrl.value)
        console.log('Exporting policy from URL:', url)
        const response = await apiStore.policyExport({
          url,
        })
        const dataUrl = bytesToObjectURL(response.tarball, 'application/gzip')
        const a = document.createElement('a')
        a.download = `policy-export-${new Date().toISOString()}.tar.gz`
        a.href = dataUrl
        a.click()
        URL.revokeObjectURL(dataUrl)
      } catch (error) {
        exportError.value = `Export Failed: ${(error as Error).message}`
        console.error(error)
      } finally {
        exportLoading.value = false
      }
    }

    return {
      // export
      exportUrl,
      exportLoading,
      exportDisabled,
      exportError,
      handleExport,
    }
  },
})
</script>
